import { render } from "./ImageAll.vue?vue&type=template&id=bcf12052"
import script from "./ImageAll.vue?vue&type=script&lang=js"
export * from "./ImageAll.vue?vue&type=script&lang=js"

import "./ImageAll.vue?vue&type=style&index=0&id=bcf12052&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__